import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/half-life-calculator',
  component: () => import('../../routes/HalfLifeCalculator.svelte'),
  card: {
    id: 'half-life-calculator',
    title: 'Half-Life Calculator',
    description: 'Calculate radioactive decay using the half-life formula. Find remaining quantity, initial amount, elapsed time, or half-life period.',
    icon: 'radioactive',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/half-life-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Half-Life Calculator – Radioactive Decay Calculator',
    description:
      'Free half-life calculator to solve any variable in radioactive decay. Calculate remaining quantity, initial amount, elapsed time, or half-life period using N(t) = N₀ × (1/2)^(t/t₁/₂).',
  },
};

export default meta;
